// /stores/time-offset.ts
import axios from 'axios'
import { create } from 'zustand'
import { appConfig } from '../configs/app'

interface TimeState {
	offset: number // ⧍ serverEpoch − clientNow  (ms)
	synced: boolean
	sync: (url?: string) => Promise<void>
}

/** Global store that holds the server–client time difference. */
export const useTimeOffset = create<TimeState>((set) => ({
	offset: 0,
	synced: false,

	async sync(url = '/time') {
		try {
			const { epoch } = await fetch(appConfig.apiUrl + url, { cache: 'no-store' }).then((r) => r.json())
			set({ offset: epoch - Date.now(), synced: true })
		} catch (err) {
			console.error('[time-sync] failed:', err)
			set({ offset: 0, synced: false })
		}
	},
}))

// local getter (works outside React render cycle)
const getOffset = () => (typeof window === 'undefined' ? 0 : useTimeOffset.getState().offset)

type DateArgs = ConstructorParameters<typeof Date>

/** Behaves like Date but always corrected by `offset` (ms). */
export default class ServerDate extends Date {
	/* overloads identical to Date */
	constructor()
	constructor(value: string | number | Date)
	constructor(y: number, m: number, d?: number, h?: number, min?: number, s?: number, ms?: number)

	// single implementation
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore – Date has many overloads, any[] is safest
	constructor(...args: DateArgs | any[]) {
		const base = args.length ? new Date(...(args as DateArgs)) : new Date()
		super(base.getTime() + getOffset())
	}

	/** Equivalent to `Date.now()` but corrected. */
	static now(): number {
		return Date.now() + getOffset()
	}
}

/* optional terse alias */
export const IsraeliDate = (...a: DateArgs) => new ServerDate(...a)
